<template>
  <v-flex xs12>
    <div></div>
    <v-title>Channel Details</v-title>
    <v-card>
      <v-layout row wrap class="ma-1">
        <v-flex xs4 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="channelManager"
            rules="required"
          >
            <v-select
              :items="admins"
              label="Channel Manager"
              :item-text="e => e.displayText"
              item-value="dealerId"
              v-model="editableDealerManager.dealerManagerId"
              :error-messages="errors"
              data-vv-name="channelManager"
              required
            ></v-select>
          </ValidationProvider>
        </v-flex>
        <v-flex xs4 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="channelLevel"
            rules="required"
          >
            <v-select
              :items="levels"
              label="Channel Level"
              item-text="text"
              item-value="value"
              v-model="editableDealerManager.levelID"
              :error-messages="errors"
              data-vv-name="channelManager"
              required
            ></v-select>
          </ValidationProvider>
        </v-flex>
        <v-flex xs4 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="status"
            rules="required"
          >
            <v-select
              :items="statusOptions"
              label="Status"
              item-text="text"
              item-value="value"
              v-model="editableDealerManager.status"
              :error-messages="errors"
              data-vv-name="channelManager"
              required
            ></v-select>
          </ValidationProvider>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>
<script>
export default {
  name: 'edit-channel-details',
  props: {
    dealerManager: {
      type: Object,
      required: true,
    },
    admins: {
      type: Array,
      required: true,
      default: [],
    },
  },
  data() {
    return {
      statusOptions: ['Prospect', 'Active', 'Onboarding', 'Signed', 'Signing'],
      levels: [
        {
          text: 'Dealer',
          value: 1,
        },
        {
          text: 'Dealer Manager',
          value: 2,
        },
        {
          text: 'Area Manager',
          value: 3,
        },
        {
          text: 'National Manager',
          value: 4,
        },
      ],
    };
  },
  computed: {
    editableDealerManager: {
      get() {
        return this.dealerManager;
      },
      set(val) {
        this.$emit('update:dealerManager', val);
      },
    },
  },
};
</script>
